import styles from './BrandMark.module.scss';

interface BrandMarkProps {
  /** Pixel size of the square mark. The wordmark scales with its own font size. */
  size?: number;
}

/**
 * The Alpantos mark: a teal core with four satellites — coral on the vertical
 * axis, blue on the horizontal.
 *
 * Copied from the two places the brand is actually defined, which agree:
 * `.logo-mark` in alpantos/marketing-website's styles.css (the nav mark on
 * alpantos.com) and `logo()` in alpantos/pdf-publisher's render.py (the mark
 * stamped on every published PDF). Both draw five plain filled dots — no rings
 * and no spokes. The `logo.svg` in public/ is the organisation's published
 * logo file, a different and busier drawing; it stays for the favicon and for
 * JSON-LD, exactly as it does on alpantos.com.
 *
 * Inline SVG rather than an <img> so the dots inherit the theme's accents and
 * stay crisp at 22px.
 */
export function BrandMark({ size = 22 }: BrandMarkProps) {
  return (
    <svg
      className={styles.mark}
      width={size}
      height={size}
      viewBox="0 0 22 22"
      role="img"
      aria-label="Alpantos"
      focusable="false"
    >
      <circle className={styles.core} cx="11" cy="11" r="3" />
      <circle className={styles.coral} cx="11" cy="2" r="2" />
      <circle className={styles.blue} cx="20" cy="11" r="2" />
      <circle className={styles.coral} cx="11" cy="20" r="2" />
      <circle className={styles.blue} cx="2" cy="11" r="2" />
    </svg>
  );
}

/**
 * Mark plus wordmark, set the way alpantos.com sets it: the display face at
 * 700 with slightly open tracking, 10px from the mark. "academy" follows in
 * the body face and the muted tone, so the group reads first and the
 * subsidiary second.
 */
export function BrandLockup() {
  return (
    <span className={styles.lockup}>
      <BrandMark />
      <span className={styles.words}>
        ALPANTOS<em className={styles.product}>academy</em>
      </span>
    </span>
  );
}
